/**
 *  设置本地缓存
 *  @public
 *  @param  _asKey 本地缓存的Key
 *          _asValue 本地缓存的value
 *  @return null
 *  @example
 *  setKeyValue('test','test`s value') //设置一天
 *
 */
export function setKeyValue(_asKey, _asValue) {
    try {
        localStorage.setItem(_asKey, _asValue);
    } catch (e) {
        if (e.toString().indexOf('QuotaExceeded') != -1) {
            localStorage.clear();
            localStorage.setItem(_asKey, _asValue);
        }
    }
}
/**
 *  读取一个本地缓存
 *  @public
 *  @param  _asKey 本地缓存的Key
 *  @return null
 *  @example
 *  getKeyValue('test') //设置一天,'test`s value'
 *
 */
export function getKeyValue(_asName) {
    //return localStorage.getItem(_asName) || cookie_get(_asName);
    return localStorage.getItem(_asName);
}

export function delKeyValue(_asName) {
    localStorage.removeItem(_asName);
}

export default {
    setKeyValue, getKeyValue, delKeyValue
}; 
